/* eslint-disable */
export const CloneDeep = obj => JSON.parse(JSON.stringify(obj));
